import React from 'react';
import { Stack } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';
import './ReportTable.css';

const SignOffApprovals = ({ formData, handleSignOffChange }) => {
    const roles = [
        { key: 'qaLead', label: 'QA Lead' },
        { key: 'devManager', label: 'Development Manager' },
        { key: 'projectManager', label: 'Project Manager' },
        { key: 'stakeholder', label: 'Stakeholder' }
    ];

    return (
        <Stack spacing={3}>
            <MaterialTypography variant="h6" fontWeight="bold">
                Sign-Off & Approvals
            </MaterialTypography>
            <div className="report-table-container">
                <table className="report-table">
                    <thead>
                        <tr>
                            <th>Role</th>
                            <th>Name</th>
                            <th>Signature</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {roles.map((role) => (
                            <tr key={role.key}>
                                <td style={{ fontWeight: '500' }}>{role.label}</td>
                                <td>
                                    <MaterialInput
                                        size="small"
                                        value={formData.signOff[role.key].name}
                                        onChange={(e) => handleSignOffChange(role.key, 'name', e.target.value)}
                                        placeholder="Enter Name"
                                        fullWidth
                                    />
                                </td>
                                <td>
                                    <MaterialInput
                                        size="small"
                                        value={formData.signOff[role.key].signature}
                                        onChange={(e) => handleSignOffChange(role.key, 'signature', e.target.value)}
                                        placeholder="Signature"
                                        fullWidth
                                    />
                                </td>
                                <td>
                                    <MaterialInput
                                        size="small"
                                        value={formData.signOff[role.key].date}
                                        onChange={(e) => handleSignOffChange(role.key, 'date', e.target.value)}
                                        placeholder="Date"
                                        fullWidth
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Stack>
    );
};

export default SignOffApprovals;
